import React from 'react';
import { Sun, Moon, Monitor } from 'lucide-react';
import { useTheme } from '../hooks/useTheme';

const OPTIONS = [
  { key: 'light', label: 'Light', Icon: Sun },
  { key: 'dark', label: 'Dark', Icon: Moon },
  { key: 'system', label: 'Auto', Icon: Monitor },
];

// Segmented Light / Dark / Auto control (Profile → Appearance).
export const ThemeSegmented = () => {
  const { preference, setPreference } = useTheme();
  return (
    <div className="inline-flex items-center gap-1 bg-[#F3F2F0] rounded-full p-1"
      role="radiogroup" aria-label="Appearance" data-testid="theme-segmented">
      {OPTIONS.map(({ key, label, Icon }) => {
        const active = preference === key;
        return (
          <button key={key} type="button" role="radio" aria-checked={active}
            onClick={() => setPreference(key)}
            data-testid={`theme-option-${key}`}
            className={`flex items-center gap-1.5 px-3.5 py-1.5 rounded-full font-sans text-[10px] uppercase tracking-[0.16em] transition-colors ${
              active ? 'bg-white text-[#0D0D0D] shadow-sm' : 'text-[#8E8A84] hover:text-[#0D0D0D]'}`}>
            <Icon size={13} strokeWidth={1.75} />
            {label}
          </button>
        );
      })}
    </div>
  );
};

// Compact cycle button (desktop sidebar footer): light → dark → system.
export const ThemeCycleButton = () => {
  const { preference, isDark, setPreference } = useTheme();
  const next = { light: 'dark', dark: 'system', system: 'light' }[preference] || 'light';
  const Icon = preference === 'system' ? Monitor : (isDark ? Moon : Sun);
  const label = preference === 'system' ? 'Auto theme' : (isDark ? 'Dark theme' : 'Light theme');
  return (
    <button type="button" onClick={() => setPreference(next)}
      aria-label={`${label} — switch`} title={`${label} — click to switch`}
      data-testid="theme-cycle-button"
      className="w-full flex items-center gap-3 px-4 py-3 rounded-xl text-[#8E8A84] hover:text-[#0D0D0D] transition-colors">
      <Icon size={17} strokeWidth={1.5} />
      <span className="font-sans text-[11px] uppercase tracking-widest">{label}</span>
    </button>
  );
};
